import lookingToMeetService from '../services/lookingToMeetService';
import * as types from '../constants/actionTypes';

export function loadLookingForDataSuccess(data) {
  return { type: types.LTM_LOAD_LOOKING_FOR_SUCCESS, data };
}

export function loadIntentionsDataSuccess(data) {
  return { type: types.LTM_LOAD_INTENTIONS_SUCCESS, data };
}

export function loadAgeRangeDataSuccess(data) {
  return { type: types.LTM_LOAD_AGE_RANGE_SUCCESS, data };
}

export function loadLookingForData(params) {
  return function (dispatch) {
    return lookingToMeetService.loadLookingForData(params).then(res => {
      if (res.success) {
        dispatch(loadLookingForDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadIntentionsData(params) {
  return function (dispatch) {
    return lookingToMeetService.loadIntentionsData(params).then(res => {
      if (res.success) {
        dispatch(loadIntentionsDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}

export function loadAgeRangeData(params) {
  return function (dispatch) {
    return lookingToMeetService.loadAgeRangeData(params).then(res => {
      if (res.success) {
        dispatch(loadAgeRangeDataSuccess({ items: res.data.items, init: params }));
      }
      return res;
    });
  };
}
